import { useTranslate } from '@tolgee/react';
import * as React from 'react';
import { useSystemLanguageValue } from 'hooks/business/system/useSystem';
import { formatNumber } from 'utils/numberFormat';

export const useUnit = (toFix: number = 0) => {
  const { t } = useTranslate();
  const lang = useSystemLanguageValue();
  const numericalValue = ['en-US', 'th', 'es'].includes(lang) ? 1000000 : 10000;
  const formatter = React.useCallback(
    (value: number | string) => {
      if (['id', 'tl', 'vi', 'es'].includes(lang)) {
        return formatNumber(value, '0,0');
      }
      const numberValue = Number(value);
      if (numberValue < numericalValue) return value;
      const youyu = numberValue % numericalValue !== 0;
      return t('order_num_unit', {
        x: (numberValue / numericalValue).toFixed(youyu ? toFix : 0),
      });
    },
    [t, toFix, numericalValue, lang],
  );

  const parser = React.useCallback(
    (value: string) => {
      return parseInt(value || '0') * numericalValue;
    },
    [numericalValue],
  );

  return {
    formatter,
    parser,
  };
};
